import { FC, useState, ReactNode, useRef } from 'react'
import { createPortal } from 'react-dom'
import styles from './Tooltip.module.sass'

interface TooltipProps {
  children: ReactNode
  text: string
}

export const Tooltip: FC<TooltipProps> = ({ children, text }) => {
  const [visible, setVisible] = useState(false)

  const containerRef = useRef<HTMLDivElement>(null)

  const getTooltipStyle = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect()
      const isMobile = window.innerWidth <= 768 // порог для мобильных устройств
      return {
        position: 'absolute',
        top: rect.bottom + window.scrollY,
        left: isMobile
          ? window.innerWidth / 2
          : rect.left + rect.width / 2 + window.scrollX,
        transform: 'translateX(-50%)',
      }
    }
    return {}
  }

  return (
    <div
      className={styles.container}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      ref={containerRef}
    >
      {children}
      {visible &&
        createPortal(
          <div className={styles.tooltip} style={getTooltipStyle()}>
            {text}
          </div>,
          document.body,
        )}
    </div>
  )
}
